export interface LabelColor {
  id: string;
  dot: string;
  bg: string;
  text: string;
}

export const LABEL_COLORS: LabelColor[] = [
  { id: 'indigo',  dot: '#6366f1', bg: 'bg-indigo-100 dark:bg-indigo-900/30',   text: 'text-indigo-700 dark:text-indigo-400'  },
  { id: 'sky',     dot: '#0ea5e9', bg: 'bg-sky-100 dark:bg-sky-900/30',         text: 'text-sky-700 dark:text-sky-400'        },
  { id: 'emerald', dot: '#10b981', bg: 'bg-emerald-100 dark:bg-emerald-900/30', text: 'text-emerald-700 dark:text-emerald-400' },
  { id: 'rose',    dot: '#f43f5e', bg: 'bg-rose-100 dark:bg-rose-900/30',       text: 'text-rose-700 dark:text-rose-400'      },
  { id: 'amber',   dot: '#f59e0b', bg: 'bg-amber-100 dark:bg-amber-900/30',     text: 'text-amber-700 dark:text-amber-400'    },
  { id: 'violet',  dot: '#8b5cf6', bg: 'bg-violet-100 dark:bg-violet-900/30',   text: 'text-violet-700 dark:text-violet-400'  },
  { id: 'orange',  dot: '#f97316', bg: 'bg-orange-100 dark:bg-orange-900/30',   text: 'text-orange-700 dark:text-orange-400'  },
  { id: 'teal',    dot: '#14b8a6', bg: 'bg-teal-100 dark:bg-teal-900/30',       text: 'text-teal-700 dark:text-teal-400'      },
  { id: 'pink',    dot: '#ec4899', bg: 'bg-pink-100 dark:bg-pink-900/30',       text: 'text-pink-700 dark:text-pink-400'      },
  { id: 'cyan',    dot: '#06b6d4', bg: 'bg-cyan-100 dark:bg-cyan-900/30',       text: 'text-cyan-700 dark:text-cyan-400'      },
];

export const DEFAULT_TYPE_COLOR = 'indigo';
export const DEFAULT_LOCATION_COLOR = 'sky';

export function getColorClasses(colorId?: string | null): LabelColor {
  return LABEL_COLORS.find(c => c.id === colorId) ?? LABEL_COLORS[0];
}
